
<template>
  <div>
    <h4 v-html="temp.text"></h4>
  </div>
</template>

<script>
  export default {
    data(){
      return{

      }
    },
    props: ['temp']
  }
</script>

<style scoped>

  div {
    height: 30px;
    background: #404342;
    border: 1px solid #dce1ec;
    color: #dce1ec;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    padding-left: 5px;
    padding-right: 5px;
  }

  h4 {
    color: lightblue;
  }

</style>



// WEBPACK FOOTER //
// src/components/hover/Mini.vue